import { Link } from 'gatsby';
import React from 'react';
import styled from 'styled-components';

import Enterprise from '../../icons/enterprise.svg';
import Au from '../../icons/flag-au.svg';
import Ca from '../../icons/flag-ca.svg';
import Eu from '../../icons/flag-eu.svg';
import Nz from '../../icons/flag-nz.svg';
import Sa from '../../icons/flag-sa.svg';
import Us from '../../icons/flag-us.svg';
import Midsize from '../../icons/midsize.svg';
import Small from '../../icons/small.svg';

const regionCards = [
  {
    label: 'United States',
    to: '/customers/united-states/pacific-northwest',
    icons: [Us]
  },
  { label: 'Canada', to: '/customers/canada/niagara', icons: [Ca] },
  {
    label: 'Australia & New Zealand',
    to: '/customers/australia-and-new-zealand/australia',
    icons: [Au, Nz]
  },
  { label: 'South Africa', to: '/customers/south-africa', icons: [Sa] },
  { label: 'Europe', to: '/customers/europe', icons: [Eu] }
];

const sizeCards = [
  { label: 'Small', to: '/customers/small', icons: [Small] },
  { label: 'Midsize', to: '/customers/midsize', icons: [Midsize] },
  { label: 'Enterprise', to: '/customers/enterprise', icons: [Enterprise] }
];

const ExploreBy = () => (
  <>
    <Group>
      <Label>Explore by region</Label>
      <Cards>
        {regionCards.map((card) => (
          <CardComponent key={card.label} card={card} />
        ))}
      </Cards>
    </Group>
    <Group>
      <Label>Explore by size</Label>
      <Cards>
        {sizeCards.map((card) => (
          <CardComponent key={card.label} card={card} />
        ))}
      </Cards>
    </Group>
  </>
);

const CardComponent = (props) => {
  const { card } = props;
  return (
    <Card to={card.to}>
      <Icons>
        {card.icons.map((icon, index) => {
          const Icon = icon;

          return (
            <IconWrapper key={String(index)}>
              <Icon />
            </IconWrapper>
          );
        })}
      </Icons>
      {card.label}
    </Card>
  );
};

const Group = styled.div`
  margin-bottom: 50px;
  &:last-of-type {
    margin-bottom: 0px;
  }
`;

const Label = styled.p`
  color: var(--gray-dark);

  font-size: var(--font-size-lg);

  margin-bottom: 40px;
`;

const Cards = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  margin: 0;
`;

const Card = styled(Link)`
  border-radius: 8px;
  box-shadow: 1px 2px 8px rgba(7, 32, 128, 0.08);
  border: 1px solid rgb(220, 223, 232);
  font-size: var(--heading-size-sm);
  background: white;
  color: var(--blue-dark);
  letter-spacing: var(--letter-spacing-wide);
  font-weight: var(--font-weight-bold);
  padding: 30px;
  margin: 0 20px 40px 0px;
  width: 100%;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  &:hover,
  &:focus {
    box-shadow: 1px 2px 11px rgba(7, 32, 128, 0.11);
    transform: translateY(-5px);
  }
  ${({ theme }) => `
  @media ${theme.mediumUp} {
    width: calc(${100 / 2}% - 20px);
  }
  @media ${theme.largeUp} {
    width: calc(${100 / 3}% - 20px);
  }
`}
`;

const Icons = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;

const IconWrapper = styled.div`
  background-color: rgb(244, 242, 255);
  margin-right: 2px;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default ExploreBy;
